import { FAKE, REAL, registerDependency } from 'components/shared/dependency-injection/dependency-injection.js'
import { GenericStorefrontAPIRequest } from 'components/discovery/shared/ecommerce-api-token/api/ecommerce-api-token-api.js'
import { parseProductOptions, type ProductOption } from 'components/discovery/pdp/product-options/api/product-options-parser.js'

export type { ProductOption } from 'components/discovery/pdp/product-options/api/product-options-parser.js'

export const productOptionsPath = (productId: number): string =>
  `api/v1/product/v2/${productId}/options/`

export class GetProductOptionsRequest extends GenericStorefrontAPIRequest { }

export interface ProductOptionsAPI {
  getProductOptions(request: GetProductOptionsRequest): Promise<ProductOption[]>
}

export class FakeProductOptionsAPI implements ProductOptionsAPI {
  productOptionRequests: GetProductOptionsRequest[] = []
  productOptionsData: ProductOption[] = []
  productOptionsError: Error | null = null

  getProductOptions(request: GetProductOptionsRequest): Promise<ProductOption[]> {
    this.productOptionRequests.push(request)
    if (this.productOptionsError) return Promise.reject(this.productOptionsError)
    return Promise.resolve(this.productOptionsData)
  }
}

export class RealProductOptionsAPI implements ProductOptionsAPI {
  async getProductOptions(request: GetProductOptionsRequest): Promise<ProductOption[]> {
    const response = await fetch(request.endpointUrl, {
      method: request.method,
      headers: request.headers,
    })

    if (!response.ok) return []

    return parseProductOptions(await response.json())
  }
}

export let productOptionsApi!: ProductOptionsAPI
registerDependency({
  [REAL]: () => productOptionsApi = new RealProductOptionsAPI(),
  [FAKE]: () => productOptionsApi = new FakeProductOptionsAPI(),
})
